export const GIVING_LINK_DIALOG_BUTTON_LABEL = 'giving-link-dialog.button-label';
export const GIVING_LINK_DIALOG_MESSAGE = 'giving-link-dialog.message';
